import styled from "styled-components";

export const Container = styled.div`
	display: flex;
	align-items: center;
	gap: 8px;
`;

export const Label = styled.label`
	color: var(--neutral-smoothest, #fff);

	font-family: var(--font-family-metropolis-regular);
	font-size: 12px;
	font-style: normal;
	font-weight: 600;
	line-height: 170%;
	cursor: pointer;

	margin: 0;
`;
